/**
 * The subject-title colour options - the ONLY per-gradebook
 * customization. The book itself (spine, grade stamp, icons, binding base) is
 * always the system green; distinguishing books is done purely by the colour of
 * the subject text. Options are drawn from the app palette (brand green + the
 * colorSystem hues), each with a light/dark text class and a solid swatch.
 */
export const TITLE_COLORS = [
  { key: "default", label: "Default", text: "text-foreground",                     swatch: "bg-foreground" },
  { key: "green",   label: "Green",   text: "text-brand-700 dark:text-brand-400",  swatch: "bg-brand-600" },
  { key: "blue",    label: "Blue",    text: "text-blue-700 dark:text-blue-400",    swatch: "bg-blue-600" },
  { key: "amber",   label: "Amber",   text: "text-amber-600 dark:text-amber-400",  swatch: "bg-amber-500" },
  { key: "red",     label: "Red",     text: "text-red-700 dark:text-red-400",      swatch: "bg-red-600" },
  { key: "slate",   label: "Slate",   text: "text-slate-600 dark:text-slate-300",  swatch: "bg-slate-500" },
];

/** Resolve a stored colour key to its Tailwind text class (falls back to default). */
export function titleColorClass(key) {
  return (TITLE_COLORS.find((c) => c.key === key) ?? TITLE_COLORS[0]).text;
}
